<template>
  <div>
    <page-container :title="breadcrumb" :breadcrumb="breadcrumb">
      <div class="bg-white">
        <div class="main-container" style="margin-top: -15px">
          <div class="title">平台参数</div>
        </div>
      </div>
      <div class="container">
        <div class="table-btns" style="margin-top: 2%">
          <a-button type="primary" size="large" @click="getOrSet" style="margin-left: 80%">
            {{status ?'下发当前参数':'获取最新参数' }}</a-button>
          <a-icon type="redo" class="after-btn table-refresh" @click="getParams" style="margin-left: 1%;font-size: 20px"></a-icon>
        </div>
        <a-form-model ref="modalForm" layout="inline" class="form-in-twocolumns"  :label-col="{span:9}" :wrapper-col="{span:14}" style="margin-top: 1%">
          <a-form-model-item label="视频轮询功能使能">
            <a-input v-model="platParams.ispolling" placeholder=""></a-input>
          </a-form-model-item>
        </a-form-model>
      </div>
    </page-container>
  </div>
</template>
<script>

import {findFlatParams, modifyFlatParams} from "A/xtpz";

export default {
  name: "functionParams",
  data() {
    return {
      breadcrumb: [
        {
          name: '通用设置',
          path: ''
        },
        {
          name: '平台参数',
          path: ''
        },
        {
          name: '平台功能参数',
          path: ''
        },
      ],
      platParams:{
        paramsid:null,
        ispolling:null,
      },
      status:false,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // this.getParams()
    },
    getParams(){
      let params={
      }
      findFlatParams(params).then(res=>{
        if(res&&res.returncode=="0"){
          this.platParams=res.item[0]
        }
      })
    },
    setParams(){
      let params=this.platParams
      modifyFlatParams(params).then(res=>{
        if(res&&res.returncode=="0"){
          this.$message.success("参数下发成功")
        }
      })
    },
    getOrSet(){
      if(this.status){
        this.setParams();
        this.status=false;
      }else{
        this.getParams();
        this.status=true
      }
    },
  }
}
</script>
<style scoped>
.bg-white {
  background-color: #fff;
}
.container{
  background-color: #fff;
  margin-left: 1%;
  margin-right: 1%;
  margin-top: 1%;
  flex-grow: 1;
  overflow: auto;
  height: 730px;
}
.title {
  font-weight: bold;
  font-size: 20px;
  padding: 5px 20px;
}
.main-container {
  display: flex;
  padding: 10px;
}

</style>